<template>
  <span>{{ formattedValue }}</span>
</template>

<script lang="ts">
import Vue from "vue";
import { formatDistance } from "@/helpers/distance-utils";

export default Vue.extend({
  name: "DistanceDisplay",
  props: {
    value: Number,
  },
  computed: {
    formattedValue(): string {
      return formatDistance(this.value);
    },
  },
});
</script>
